<div class="page-wrapper">
  <div class="row no-gutter">
    <div class="col-sm-12">
      
      <amazon-header></amazon-header>
    </div>

   <div class="col-sm-12 content">
    <h1 *ngIf="!deleted">Please read this carefully
      You are about to submit a request for us to permanently close your account
       and delete your data. Once your account is closed all of the services accessed 
       through your account will no longer be available to you, across any sites globally.</h1>
       <h1 *ngIf="deleted">Your request has been submitted.<br>Your account will be deleted within 30 days.
       </h1>
   </div>
   <div class="text-center" *ngIf="!deleted">
    <button type="button" class="btn btn-primary" (click)="deleteUser()">Delete Account</button>
   </div>
   <div class="text-center" *ngIf="deleted">
    <button type="button" class="btn btn-primary" (click)="navigate()">Okay</button>
   </div>
    <div>
      <amazon-footer></amazon-footer>
    </div>
  </div>
</div>

